import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const VOLTAGE_DEFAULT_UNIT = 'V' as const;

const units = ['V', 'kV'] as const;
const unit = z.literal(VOLTAGE_DEFAULT_UNIT).default(VOLTAGE_DEFAULT_UNIT);

const validator = AbstractMeasurement.minNomMax
    .extend({
        unit,
    })
    .default({});

const valueValidator = AbstractMeasurement.value
    .extend({
        unit,
    })
    .default({});

export const Voltage = {
    validator,
    validators: {
        value: valueValidator,
        unit,
    },
    units,
    defaultUnit: VOLTAGE_DEFAULT_UNIT,
};

export type Voltage = z.infer<typeof validator>;
